/* eslint-disable */
// 数据更新
export const LOGIN_RECORD_UPDATE_DATA = 'LOGIN_RECORD_UPDATE_DATA';
// loading
export const LOGIN_RECORD_LOADING = 'LOGIN_RECORD_LOADING';
export const GET_AGENT_NAME_LIST = `ADMIN_USER_AGENT_NAME_LIST`;
